import { useQuery, useMutation, useQueryClient, keepPreviousData } from '@tanstack/react-query';
import apiClient from './apiClient';
import { invalidateMaterialReports } from './useMaterialReports';

export const materialCostKeys = {
  all: ['materialCosts'],
  stocks: (filters) => ['materialCosts', 'stocks', filters],
};

/** Consulta cobertura de la existencia física para su revisión, con filtros y orden. */
export const useMaterialValuationStocks = (filters = {}) =>
  useQuery({
    queryKey: materialCostKeys.stocks(filters),
    queryFn: async () => (await apiClient.get('material_costs/stocks', { params: filters })).data,
    placeholderData: keepPreviousData,
  });

/** Previsualiza o aprueba la apertura; no envía USD ni cotizaciones. */
export const useMaterialOpening = (action) => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: async (payload) =>
      (await apiClient.post(`material_costs/openings/${action}`, payload)).data,
    onSuccess: () => {
      if (action === 'confirm') {
        client.invalidateQueries({ queryKey: materialCostKeys.all });
        invalidateMaterialReports(client);
      }
    },
  });
};

/** Compras o retornos legacy que aún necesitan respaldo de valoración (página y orden). */
export const useMaterialValuationPreflight = (filters = {}) =>
  useQuery({
    queryKey: [...materialCostKeys.all, 'preflight', filters],
    queryFn: async () =>
      (await apiClient.get('material_costs/preflight', { params: filters })).data,
    placeholderData: keepPreviousData,
  });

/** Lee capas y remanentes del artículo sin pedir USD al operador. */
export const useMaterialCostLayers = (filters, options = {}) =>
  useQuery({
    queryKey: [...materialCostKeys.all, 'layers', filters],
    queryFn: async () => (await apiClient.get('material_costs/layers', { params: filters })).data,
    placeholderData: keepPreviousData,
    ...options,
  });

/** Última apertura aprobada de una existencia: valores, cotización, respaldo y aprobador. */
export const useMaterialOpeningDetail = (stockId) =>
  useQuery({
    queryKey: [...materialCostKeys.all, 'opening', stockId],
    queryFn: async () => (await apiClient.get(`material_costs/stocks/${stockId}/opening`)).data,
    enabled: Boolean(stockId),
  });
